import m from 'mithril';
import paymentSession from '../lib/paymentSession';

let result;
const vwEcomConfirmation = {
	oninit: async ({ attrs: { sessionId, sessionComplete = () => {} } }) => {
		result = false;
		const checkStatus = async () => {
			const statusResult = await paymentSession.getStatus(sessionId);

			if (statusResult.success == false) {
				setTimeout(checkStatus, 2000);
			} else {
				result = statusResult.data.status;
				sessionComplete();
			}

			m.redraw();
		};

		await checkStatus();
	},
	view: () => {
		return result ? m('div', result) : null;
	},
};

export default vwEcomConfirmation;
